import React from "react";

import { colors, fonts } from "@apps/viewer/src/ts/config";

/**
 * Injects global stylesheet into the DOM.
 */
export const CSS: React.FC = () => (
  <React.Fragment>
    <style jsx global>{`
      html,
      body {
        /** Reset margins and paddings */
        margin: 0;
        padding: 0;

        /** Fill up the viewport */
        box-sizing: border-box;
        min-width: 100%;
        min-height: 100%;

        /** Apply default background color */
        background-color: #f7f7f7;
      }

      body {
        /** Set up basic font */
        color: ${colors.black};
        font-family: ${fonts.franklin};
        font-size: 18px;
        line-height: 1.556;
      }

      #app {
        /** Fill up the viewport */
        min-width: 100%;
        min-height: 100%;

        /** Use flexbox inside on the y-axis */
        display: flex;
        flex-direction: column;
      }

      * {
        /** Disable default touch-tap-highlight */
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

        /** Disable default outline on focus */
        outline: 0;
      }

      /**
             * NPROGRESS STYLING
             */
      #nprogress {
        pointer-events: none;
      }

      #nprogress .bar {
        background: #dc4320;
        position: fixed;
        z-index: 1031;
        top: 0;
        left: 0;
        width: 100%;
        height: 2px;
      }

      #nprogress .peg {
        display: block;
        position: absolute;
        right: 0;
        width: 100px;
        height: 100%;
        box-shadow:
          0 0 10px #dc4320,
          0 0 5px #dc4320;
        opacity: 1;
        transform: rotate(3deg) translate(0, -4px);
      }

      /* latin-ext */
      @font-face {
        font-family: "figtree";
        font-weight: 300 900;
        font-style: italic;

        src: url("./public/fonts/figtree-latin-italic-ext.woff2")
          format("woff2");
        unicode-range:
          U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF,
          U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020,
          U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }

      /* latin */
      @font-face {
        font-family: "figtree";
        font-weight: 300 900;
        font-style: italic;

        src: url("./public/fonts/figtree-latin-italic.woff2") format("woff2");
        unicode-range:
          U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,
          U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193,
          U+2212, U+2215, U+FEFF, U+FFFD;
      }

      /* latin-ext */
      @font-face {
        font-family: "figtree";
        font-weight: 300 900;
        font-style: normal;

        src: url("./public/fonts/figtree-latin-ext.woff2") format("woff2");
        unicode-range:
          U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF,
          U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020,
          U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
      }

      /* latin */
      @font-face {
        font-family: "figtree";
        font-weight: 300 900;
        font-style: normal;

        src: url("./public/fonts/figtree-latin.woff2") format("woff2");
        unicode-range:
          U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC,
          U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193,
          U+2212, U+2215, U+FEFF, U+FFFD;
      }
    `}</style>
  </React.Fragment>
);
